import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-geo-fence-side-bar",
	templateUrl: "./geo-fence-side-bar.component.html",
	styleUrls: ["./geo-fence-side-bar.component.css"],
})
export class GeoFenceSideBarComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() SelectedChanged: EventEmitter<any> = new EventEmitter();
	@Output() CenterOn: EventEmitter<any> = new EventEmitter();
	@Output() EditGeoFence: EventEmitter<any> = new EventEmitter();
	@Output() SaveGeoFence: EventEmitter<any> = new EventEmitter();

	EditingID: any = -1;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGeoFences: any = [];
	@Input() lstGeoFence: any = [];

	//Filter lists
	lstActiveDesc: any = [];
	lstSeverityDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "GeoFenceDesc", header: "Description" },
		{ field: "SeverityDesc", header: "Severity" },
		{ field: "AlertComments", header: "Comments" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		this.lstSeverityDesc = Array.from(new Set(this.lstGeoFence.map((item: any) => item.SeverityDesc))).sort();
		this.lstActiveDesc = Array.from(new Set(this.lstGeoFence.map((item: any) => item.ActiveDesc))).sort();

		this.onRowUnselect(null);
	}

	// loadGeoFence(){
	//   var result = this.GeoFenceService.LoadGeoFence("PARMSLIST");
	//   result.subscribe(
	//     response => {
	//       this.lstGeoFence = response;

	//       //Load Data Filter Lists
	//

	//     },
	//     error => {
	//     }
	//   )
	// }

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		// this.loadGeoFence();
	}

	//Custom Button Methods
	onEdit(GeoFence) {
		this.onRowSelect(GeoFence);

		this.EditingID = GeoFence.GeoFenceID;

		this.EditGeoFence.emit(GeoFence);
	}

	onSave(GeoFence) {
		// console.log("On Save");
		this.SaveGeoFence.emit(GeoFence);
		this.SelectedGeoFences = [];
		this.SelectedChanged.emit(this.SelectedGeoFences);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedChanged.emit(this.SelectedGeoFences);
		this.CenterOn.emit(val);
		// this.SelectedGeoFence = val.data;
	}
	onRowUnselect(val) {
		this.SelectedChanged.emit(this.SelectedGeoFences);
		// this.SelectedGeoFence = null;
	}
	onRowDblClick(GeoFence) {
		// this.SelectedGeoFence = GeoFence;
	}
	onHeaderCheckboxToggle(val) {
		this.SelectedChanged.emit(this.SelectedGeoFences);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsEditing(GeoFenceID) {
		var ans = false;

		if (GeoFenceID == this.EditingID) {
			ans = true;
		}

		return ans;
	}

	////////////////////////////////////////////
}
